import { useVenereExperts } from "../../experts/hooks"
import VenereAvatar from "../../shared/core/VenereAvatar"
import VenerePlatformLayout from "../../shared/pages/VenerePlatformLayout"
import VenereChatPreview from "../components/VenereChatPreview"
import { mockedPsychologist } from "../utils/mockedExperts"

const VenereChatPage = () => {
  const { nutritionist, physician, admin } = useVenereExperts()

  return (
    <VenerePlatformLayout>
      <div className="p-4 space-y-4 md:p-8">
        <div className='flex flex-col items-center gap-4'>
          <div className='venere-text-heading text-center'>
            Hai bisogno di risposte veloci?
          </div>
          <div className='venere-text-subheading text-center'>
            Chatta ora con la tua Medical Equipe
          </div>
          <VenereAvatar
            variant="welcome"
            size="xl"
          />
        </div>
        
        {physician && <VenereChatPreview expert={physician} />}
        {nutritionist && <VenereChatPreview expert={nutritionist} />}
        <VenereChatPreview expert={mockedPsychologist} />
        {admin && <VenereChatPreview expert={admin} />}
      </div>
    </VenerePlatformLayout>
  )
}

export default VenereChatPage
